(function () {
  const GIFT_WRAP_VARIANT_ID = 46975867945210;

  function getProductForm(target) {
    if (!target || !(target instanceof HTMLElement)) return null;
    return target.closest('form[action*="/cart/add"]');
  }

  function escapeSelectorValue(value) {
    if (window.CSS && CSS.escape) {
      return CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function getCheckboxFromForm(form) {
  return (
    form.querySelector('[data-free-gift-wrap-checkbox]:checked') ||
    document.querySelector('[data-free-gift-wrap-checkbox][form="' + escapeSelectorValue(form.id) + '"]:checked') ||
    document.querySelector('[data-free-gift-wrap-checkbox]:checked')
  );
}

  function getGiftWrapContainer(form) {
    return (
      form.querySelector('[data-free-gift-wrap]') ||
      document.querySelector('[data-free-gift-wrap][data-product-form-id="' + escapeSelectorValue(form.id) + '"]')
    );
  }

  function getSelectedVariantId(formData) {
    return formData.get('id');
  }

  function getQuantity(formData) {
    const qty = parseInt(formData.get('quantity') || '1', 10);
    return Number.isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function getLineItemProperties(formData) {
    const properties = {};

    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && key.endsWith(']')) {
        const propName = key.replace('properties[', '').replace(']', '');
        properties[propName] = value;
      }
    }

    return properties;
  }

  function setSubmitButtonsLoading(form, isLoading) {
    const submitButtons = Array.from(form.elements).filter((element) => element.type === 'submit');

    submitButtons.forEach((button) => {
      if (isLoading) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      } else {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    });
  }

  async function addMainAndGiftWrap(form) {
    const formData = new FormData(form);
    const variantId = getSelectedVariantId(formData);

    if (!variantId) {
      throw new Error('Variant ID not found in product form.');
    }

    const quantity = getQuantity(formData);
    const properties = getLineItemProperties(formData);
    const sellingPlan = formData.get('selling_plan');

    const sectionsToBundle = [];

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    const mainItem = {
      id: Number(variantId),
      quantity: quantity
    };

    if (Object.keys(properties).length > 0) {
      mainItem.properties = properties;
    }

    if (sellingPlan) {
      mainItem.selling_plan = sellingPlan;
    }

    const giftItem = {
      id: Number(GIFT_WRAP_VARIANT_ID),
      quantity: 1,
      properties: {
        '_gift_wrap': 'ギフトラッピング',
        '_gift_wrap_for_variant_id': String(variantId)
      }
    };

    const payload = {
      items: [mainItem, giftItem],
      sections: sectionsToBundle.join(','),
      sections_url: window.location.pathname
    };

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });

    const responseJson = await response.json();

    if (!response.ok) {
      throw new Error(responseJson.description || responseJson.message || 'Failed to add items to cart.');
    }

    const cartContent = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
    cartContent.sections = responseJson.sections;

    form.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
          cart: cartContent,
          onSuccessDo: 'force_open_drawer'
        }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          onSuccessDo: 'force_open_drawer',
          cart: cartContent
        }
      })
    );

    return responseJson;
  }

  document.addEventListener(
    'submit',
    async function (event) {
      const form = getProductForm(event.target);
      if (!form) return;

      const checkbox = getCheckboxFromForm(form);

if (!checkbox) return;

      if (form.dataset.freeGiftWrapSubmitting === 'true') {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      form.dataset.freeGiftWrapSubmitting = 'true';
      setSubmitButtonsLoading(form, true);

      document.documentElement.dispatchEvent(
        new CustomEvent('theme:loading:start', { bubbles: true })
      );

      try {
        await addMainAndGiftWrap(form);
      } catch (error) {
        console.error('Gift wrap add-to-cart error:', error);

        form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: {
              error: 'カート追加時にエラーが発生しました。もう一度お試しください。'
            }
          })
        );

        alert('カート追加時にエラーが発生しました。もう一度お試しください。');
      } finally {
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:loading:end', { bubbles: true })
        );

        form.dataset.freeGiftWrapSubmitting = 'false';
        setSubmitButtonsLoading(form, false);
      }
    },
    true
  );
})();